module.exports = __webpack_public_path__ + "static/media/Contents, Ingredients and Packaging.29f26b50.png";